import * as React from 'react';
import CollapsibleCard from '../../../../common/CollapsibleCard';
import FormInput from '../../../../common/form/Input';
import {
    getDoors, LatchDoors, LatchAdvPropertyConfiguration, LatchPropertyConfiguration,
    LatchKey,
    deleteLatchKey,
    addLatchKey
    //deleteLatchConfiguration
} from '../../../../../api/PropertyIntegration';
import Button from '../../../../common/form/Button';
// import { bmxConfig } from '../../../../../api/Shared';
import { useState, useEffect } from 'react';
import Modal from 'reactstrap/lib/Modal';
import LoadingOverlay from '../../../../common/LoadingOverlay';
import ModalHeader from 'reactstrap/lib/ModalHeader';
import ModalBody from 'reactstrap/lib/ModalBody';
import Container from 'reactstrap/lib/Container';

import { ApiResult } from '../../../../../api/Shared';
import LatchKeyRow from './LatchKeyRow';
import NewLatchKeyRow from './NewLatchKeyRow';
import FormValidationDisplay from '../../../../common/form/ValidationDisplay';
import Label from 'reactstrap/lib/Label';
import Table from 'reactstrap/lib/Table';
import FormSelectLabeled from '../../../../common/form/SelectLabeled';
import { userIsCompanyManageUser, userIsPropertyManageUser, userIsSystemManageUser } from '../../../../../utilities/identity';

interface Props {
    config?: LatchAdvPropertyConfiguration;
    update: (newConfig?: LatchAdvPropertyConfiguration) => void;
    propertyId: number;
    //Begin Latch keys
    //propertyId_key: number;
    config_key?: LatchPropertyConfiguration | undefined;
    setPageError: (error?: string) => void;
    setPageLoading: (isLoading: boolean) => void;
    update_key: (newConfig_key?: LatchPropertyConfiguration) => void;
    latchConfigOpen: boolean
    setLatchOpen: (open: boolean) => void;
    //End Latchkeys
}


const LatchAdvConfigurationSection = (props: Props) => {
    const isUser =
    userIsCompanyManageUser() ||
    userIsPropertyManageUser() ||
    userIsSystemManageUser();
    const [modalOpen, setModalOpen] = useState(false);
    const [loading, setIsLoading] = useState(false);
    const [resetTrigger, setResetTrigger] = useState(0);
    const [selectedBuilding, setSelectedBuilding] = useState('0' as string | undefined);
    const [error, setError] = useState<string | undefined>(undefined);
    const [doorList, setLatchList] = useState([] as LatchDoors[]);
    const [orgDoorList, setOrgDoorList] = useState([] as LatchDoors[]);
    const [buildingInfo, setBuildingInfo] = useState([] as { value: string; label: string; }[]);
    //Begin Latch Keys
    //const [error_key, setError_key] = useState<string | undefined>(undefined);

    useEffect(() => {
        if (selectedBuilding === '0') {
            setLatchList(orgDoorList);
        } else {
            const filteredData = orgDoorList.filter((item: LatchDoors) => {
                return item.buildingId === selectedBuilding
            });
            setLatchList(filteredData);
        }
    }, [selectedBuilding])


    const keysFromLatchConfiguration =
        props.config_key === null || props.config_key === undefined
            ? ([] as LatchKey[])
            : props.config_key.latchKeys;

    //End Latch keys
    const handleDoorViewList = async () => {

        setModalOpen(true);
        setIsLoading(true);

        let doorListResult = await getDoors(props.propertyId);
        if (doorListResult.success && doorListResult.data) {
            const doorList = doorListResult.data;
            const uniqueBuildingInfoArray: { label: string; value: string; }[] = [
                {
                    label: '- - Select Building - -',
                    value: '0'
                }
            ];
            const seenCombinations = new Set();
            setBuildingInfo(uniqueBuildingInfoArray);
            const sortedDoorList = doorList.sort((a, b) => {
                const uuidA = a.buildingName.toUpperCase(); // ignore case
                const uuidB = b.buildingName.toUpperCase();
                if (uuidA < uuidB) {
                    return -1;
                }
                if (uuidA > uuidB) {
                    return 1;
                }
                return 0; // UUIDs are equal
            });
            sortedDoorList.forEach(({ buildingId, buildingName }) => {
                const combination = `${buildingId}_${buildingName}`;
                if (!seenCombinations.has(combination)) {
                    seenCombinations.add(combination);
                    uniqueBuildingInfoArray.push({ value: buildingId, label: buildingName });
                }
            });
            setOrgDoorList(sortedDoorList);
            setLatchList(sortedDoorList);
        } else if (doorListResult.error) {
            setError(doorListResult.error);
            console.log(error);
        } else {
            setLatchList([]);
        }
        setIsLoading(false);
        //console.log(tenantList);
    };

    const close = () => {
        setModalOpen(false);
        setError(undefined);
    };

    // const handleButterflyMXLogin = async () => {

    //     //TODO move this from front end to backend
    //     // const clientId = 'c8a0f39572fdbee4a33e320ecb63011ad66eecda0600273955015dcd111ed180';
    //     // const clientSecret = '1cacde46e5e81a3d58917741b3bc72f5254c4200c77e4ac9c02f97ee4073218a';

    //     // //TODO replace this with relative url and attach property id to this
    //     // const redirectUri = 'urn:ietf:wg:oauth:2.0:oob';
    //     // const responseType = 'code';

    //     //TODO Read this url from bmx config properties
    //     if (bmxConfig.env == "local" || bmxConfig.env == "dev") {
    //         const authUrl = `http://accountssandbox.butterflymx.com/oauth/authorize?prompt=login&client_id=${bmxConfig.clientId}&redirect_uri=${bmxConfig.redirectUri}&client_secret=${bmxConfig.clientSecret}&response_type=${bmxConfig.responseType}`;
    //         window.open(authUrl);
    //     } else {
    //         const authUrl = `http://accountssandbox.butterflymx.com/oauth/authorize?prompt=login&client_id=${bmxConfig.clientId}&redirect_uri=${bmxConfig.redirectUri}?propertyid=${props.propertyId}&client_secret=${bmxConfig.clientSecret}&response_type=${bmxConfig.responseType}`;
    //         window.location.href = authUrl;
    //     }

    // };

    //Begin LatchKeys
    function callApiAction<T>(
        apiFunction: () => Promise<ApiResult<T>>,
        successFunction: (data?: T) => void,
        errorDefault: string
    ) {
        return async () => {
            setError(undefined);
            setIsLoading(true);
            let result = await apiFunction();
            setIsLoading(false);
            if (result.success) {
                successFunction(result.data);
            } else {
                setError(result.error || errorDefault);
            }
        };
    }

    const handleKeyDelete = async (keyId: string) => {
        //setIsLoading(true);
        props.setPageLoading(true);
        if (!keysFromLatchConfiguration) {
            return;
        }

        await callApiAction(
            () => deleteLatchKey(props.propertyId, keyId),
            () =>
                props.update_key({
                    latchKeys: keysFromLatchConfiguration.filter(key => key.keyId !== keyId)
                }),
            'Failed to delete key'
        )();
        //setIsLoading(false);
        props.setPageLoading(false);
    };

    const handleKeyAdd = async (keyId: string, type: string) => {
        //setIsLoading(true);
        props.setPageLoading(true);
        await callApiAction(
            () => addLatchKey(props.propertyId, keyId, type),
            () =>
                props.update_key({
                    latchKeys:
                        keysFromLatchConfiguration === undefined
                            ? ([{ keyId: keyId, type: type }] as LatchKey[])
                            : keysFromLatchConfiguration.concat({ keyId, type })
                }),
            'Failed to add key'
        )();
        //setIsLoading(false);
        setResetTrigger(resetTrigger + 1);
        props.setPageLoading(false);

    };

    // const handleConfigDelete = async () => {
    //     props.setPageLoading(true);
    //     await callApiAction(
    //         () => deleteLatchConfiguration(props.propertyId),
    //         () => props.update_key(undefined),
    //         'Failed to delete configuration'
    //     )();
    //     props.setPageLoading(false);
    // };
    //End Latchkeys
    return (
        <CollapsibleCard
    cardTitle="Latch Access"
    cardOpen={props.latchConfigOpen}
    onCardOpenChange={newValue => {
        if (!isUser) {
            props.setLatchOpen(newValue);
        }
    }}
>
            <div>
                <>
                    {/*                         <FormInput
                            labelProps={{
                                labelText: 'Tenant Email'
                            }}
                            inputProps={{
                                id: 'bmx-tenant-email',
                                name: 'emailId',
                                value: props.config.email || '',
                                type: 'string'

                            }}
                            onChange={(_name, value) =>
                                props.update({ ...props.config!, email: value.toString() })
                            }
                        /> */}
                    <FormInput
                        labelProps={{
                            labelText: 'Building Id',
                            invalidText: 'Please enter the Building ID'
                        }}
                        inputProps={{
                            id: 'latch-building-id',
                            name: 'tenantId',
                            value: props.config && props.config.buildingId ? props.config.buildingId : '',
                            type: 'string',
                            required: props.config_key && props.config_key.latchKeys && props.config_key.latchKeys.length > 0 ? false : true,
                            disabled: isUser

                        }}
                        onChange={(_name, value) =>
                            !isUser && props.update({ ...props.config!, buildingId: value.toString() })
                        }
                    />
                    <Button
                        text="View Door List"
                        onClick={handleDoorViewList}
                        addlClassName="btn-primary"
                        disabled={isUser}
                    >
                    </Button>
                    <Modal isOpen={modalOpen} toggle={close} className="latch-door-modal modal-lg">
                        <LoadingOverlay show={loading} inBootstrapColumn={false} />
                        <ModalHeader toggle={close}>Latch Door List</ModalHeader>
                        <ModalBody>
                            <div className='d-flex justify-content-end'>
                                <FormSelectLabeled
                                    selectProps={{
                                        id: 'request-sync-Property-units-Availability',
                                        name: 'syncPropertyUnitsAvailability',
                                        value: selectedBuilding,
                                        disabled: isUser,
                                    }}
                                    labelProps={{
                                        labelText: '',
                                    }}
                                    selectOptions={buildingInfo}
                                    onChange={(name, value) => {
                                        if (!isUser) {
                                        setSelectedBuilding(`${value}`);
                                    }}}
                                    className="col-6 p-0"
                                />
                            </div>
                            {!loading && (
                                <Table bordered={true}>
                                    <thead>
                                        <tr>
                                            <th className="item"> Door UUID </th>
                                            <th className="item"> Door Name </th>
                                            <th className="item"> Type </th>
                                            <th className="item"> Building Uuid </th>
                                            <th className="item"> Building Name </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {doorList && (
                                            doorList.map((door, index) => {
                                                return (
                                                    <tr key={`t-row-${index}`}>
                                                        <td>   <span className="item"> {door.doorUUid} </span></td>
                                                        <td>   <span className="item"> {door.doorName} </span></td>
                                                        <td>   <span className="item"> {door.doorType} </span></td>
                                                        <td>   <span className="item"> {door.buildingId} </span></td>
                                                        <td>   <span className="item"> {door.buildingName} </span></td>
                                                    </tr>
                                                )
                                            })
                                        )}
                                    </tbody>
                                </Table>
                            )}
                        </ModalBody>
                    </Modal>

                </>
                <div className='center'>
                    <Label > (or) </Label>
                    <hr className='latch-hr' />
                </div>
                <div>
                    {(
                        <Container>
                            <FormValidationDisplay errorMessage={error} />
                            {props.config_key &&
                                props.config_key.latchKeys &&
                                props.config_key.latchKeys.map(key => (
                                    <LatchKeyRow keyId={key.keyId} type={key.type} deleteKey={handleKeyDelete} />
                                ))}
                            <NewLatchKeyRow onKeyAdd={handleKeyAdd} resetTrigger={resetTrigger} />
                        </Container>
                    )}
                </div>
            </div>

        </CollapsibleCard>
    );
}

export default LatchAdvConfigurationSection;



// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/integrationControls/LatchAdvConfigurationSection.tsx